import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.section`
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    min-width: 100%;
    max-height: calc(100vh - 80px);
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  padding: 10px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => theme.colors.primary};
`;

export const Title = styled.h1`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 10px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  border: 1px solid ${({ theme }) => darken(0.1, theme.colors.background)};
`;

export const Name = styled.h2`
  font-size: 22px;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const Item = styled.div`
  display: flex;
  gap: 5px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  & > :not(:first-child) {
    margin-left: 10px;
    display: list-item;
    list-style-type: disc;
    list-style-position: inside;
  }
`;

export const Key = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => darken(0.1, theme.colors.textBackground)};
`;

export const Value = styled.a`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textBackground};

  &:empty {
    display: none;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
